import { render, staticRenderFns } from "./CohortLearnersPage.vue?vue&type=template&id=eb4ddb6e&scoped=true"
import script from "./CohortLearnersPage.vue?vue&type=script&lang=js"
export * from "./CohortLearnersPage.vue?vue&type=script&lang=js"
import style0 from "./CohortLearnersPage.vue?vue&type=style&index=0&id=eb4ddb6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4ddb6e",
  null
  
)

export default component.exports